module.exports = "/_next/static/images/da0fcf7324d37d63e1b3c2ee5d016e8c-prepayment_add.png";